import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import DropdownSection from "../dropdowns/startsection";
import {sections} from "../dropdowns/content";


import {StartStyle} from '../styles'
import Button from "@mui/material/Button";

const Start = () => {
    const location = useLocation()

    // Handle hash scrolling
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '')
            // Use setTimeout to ensure DOM is fully rendered and any animations complete
            const timeoutId = setTimeout(() => {
                const element = document.getElementById(id)
                if (element) {
                    // Scroll with offset to account for fixed navbar
                    const yOffset = -80
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
                    window.scrollTo({ top: y, behavior: 'smooth' })
                }
            }, 300)

            return () => clearTimeout(timeoutId)
        }
    }, [location.hash])

    return (
        <>
            <Box sx={{...StartStyle.HeadContainer}}>
                <Container {...StartStyle.HeadContainerMargins}>
                    <Typography {...StartStyle.HeadTitle} gutterBottom marginTop='10px'>
                        Start Here
                    </Typography>
                    <Typography {...StartStyle.HeadContent} gutterBottom marginTop='10px'>
                        Interested in AI in healthcare, but don't know where to start?
                    </Typography>
                    <Typography {...StartStyle.HeadContent} gutterBottom marginTop='10px' marginBottom='10px'>
                        We've got you covered!
                    </Typography>
                </Container>
            </Box>
            <Box id='learn-contianer' sx={{...StartStyle.SectionContainer}}>
                <Typography gutterBottom variant='h4' align='center' marginBottom='20px'>
                    New to AI in healthcare?
                </Typography>
                <Button variant='contained' href='/quiz' sx={{...StartStyle.QuizButton}}>
                    Take our user Quiz to get started
                </Button>
                <Typography gutterBottom variant='h4' align='center' marginBottom='40px'>
                    Follow the sections below to get started!
                </Typography>
                <Container maxWidth='lg' sx={StartStyle.DropdownContainer}>
                    {sections.map((section, index) => (
                        <Box key={index} sx={StartStyle.DropdownSection} mb={1} mt={2}>
                            <DropdownSection title={section.title} content={section.content}/>
                        </Box>
                    ))}
                </Container>
            </Box>
        </>
    )
}

export default Start
